/**
 * What a standard check is, and what it says (IM-199).
 *
 * ## A check is a pure function over facts
 *
 * The reads happen in the handler and the adapters, once per run; a check only
 * judges what they found. That is the onboarding assessment's shape, and for
 * its reason: the API runs the checks and the console renders the answer, so
 * the screen and the API cannot disagree about whether something is wrong.
 *
 * ## Unknown is not done
 *
 * A check whose facts could not be read says `unknown`, with the reason — never
 * `ok`, and never absent. A Debug tab that showed a green row because a call
 * timed out would send somebody away from exactly the instance they should be
 * looking at. `not-applicable` is separate from both: an instance on in-cluster
 * search has no managed domain to judge, which is neither a pass nor a gap.
 *
 * ## Written for a customer to read
 *
 * The Debug tab is staff-only for now, and nothing on it may be something a
 * customer could not be shown. So a finding, a recommendation and every
 * evidence label name this instance's own things in plain words: no other
 * customer, no ticket key, no note meant for Qrvey only. `registry.test.ts`
 * scans every check's output for issue keys rather than trusting this
 * paragraph.
 */
export const CHECK_OUTCOMES = ['fail', 'warn', 'unknown', 'ok', 'not-applicable'];
/**
 * What a check is about, so later checks join a group rather than the tab
 * growing a new section per story.
 */
export const CHECK_CATEGORIES = [
    'capacity',
    'network',
    'managed-services',
    'cost',
    'cluster',
    'observability',
    'customer-stacks',
];
/**
 * The answer for a section that was not read, in the section's own words.
 *
 * A check calls this first and judges only a `read` section, so "the account
 * refused" and "there is nothing here to judge" each reach the tab as what
 * they are.
 */
export const unread = (gathered, what) => {
    switch (gathered.state) {
        case 'read':
            return { value: gathered.value };
        case 'unreadable':
            return {
                outcome: 'unknown',
                finding: `Could not read ${what}.`,
                evidence: [{ label: 'Reason', value: gathered.reason }],
            };
        case 'not-applicable':
            return { outcome: 'not-applicable', finding: gathered.reason, evidence: [] };
    }
};
export const isEvaluation = (value) => 'outcome' in value;
//# sourceMappingURL=model.js.map